export default __webpack_public_path__ + "static/media/marker.eb318b54.svg";